<script lang="ts">
	import Select, { Option } from '@smui/select'
	import { orderFilterProducts, type ProductsEndpoint } from '$lib/js/products'
	import { setSearchParam } from '$lib/js/helpers'
	import { getContextScope } from '$lib/js/helpers/i18n'
	import { onMount } from 'svelte'
	import { page } from '$app/stores'
	import { t } from 'svelte-i18n-lingui'
	import type { BaseProduct, FullProduct, ProductQueryOptions } from '$lib/js/elasticsearch/types'
	import '$lib/css/components/select.scss'

	// TODO[typing] properly type this
	export let products: (BaseProduct | FullProduct)[] = []
	export let options: ProductQueryOptions
	export let endpoint: ProductsEndpoint

	const scope = getContextScope()
	let sort = $page.url.searchParams.get('sort') || 'rating'
	let sorting: undefined | Array<{ label: string; value: string }> = undefined

	onMount(async () => {
		const sorting_pre = await import(`$lib/js/constants/sorting_${scope}.json`)
		sorting = sorting_pre.default
	})
</script>

{#if sorting}
	<div class="sort-items">
		<div class="u-select sort sort-items">
			<Select
				on:SMUIMenu:selected={async () => {
					options.sort = sort
					setSearchParam('sort', sort)
					products = await orderFilterProducts(options, endpoint, { scope: scope })
				}}
				bind:value={sort}
				label={$t`Sort`}
			>
				{#each sorting as option}
					<Option value={option.value}>{option.label}</Option>
				{/each}
			</Select>
		</div>
	</div>
{/if}

<style lang="scss">
	.sort-items {
		display: flex;
		justify-content: flex-end;
	}

	.u-select {
		width: 100%;
		display: flex;

		@media (min-width: 481px) {
			max-width: 260px;
		}

		@media (min-width: 1025px) {
			margin-bottom: 20px;
		}
	}
</style>
